(() => {
  const dialog = document.getElementById('pu-team-dialog');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const page = document.querySelector('[data-pu-team]');
  if (page) page.classList.add('is-enhanced');
  const body = dialog.querySelector('.pu-team-dialog__body');
  let opener;
  document.querySelectorAll('[data-team-profile-open]').forEach(trigger => {
    trigger.addEventListener('click', event => {
      const source = [...document.querySelectorAll('[data-team-profile-key]')].find(profile => profile.dataset.teamProfileKey === trigger.dataset.teamProfileOpen && !dialog.contains(profile));
      if (!source) return;
      event.preventDefault();
      opener = trigger;
      dialog.querySelector('#pu-team-name').textContent = source.dataset.teamName;
      const role = dialog.querySelector('#pu-team-role');
      role.textContent = source.dataset.teamRole;
      role.hidden = !source.dataset.teamRole;
      body.replaceChildren(source.cloneNode(true));
      dialog.showModal();
      // The stylesheet locks page scrolling from this body class: a body:has([open]) check
      // made Chrome re-style the whole page on every DOM change anywhere (INP).
      document.body.classList.add('pu-team-dialog-open');
      body.scrollTop = 0;
      dialog.querySelector('.pu-team-close').focus();
    });
  });
  dialog.querySelector('.pu-team-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
  });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => { document.body.classList.remove('pu-team-dialog-open'); body.replaceChildren(); if (opener) opener.focus({preventScroll:true}); });
})();
